import React from "react";
import NumberFormat from "react-number-format";
import { RenderKilogramo } from "../../../../../../Utils/renderField/renderReadField";
import { BuscadorExistencias } from "./BuscadorExistencias";
import { getEtiquetasTraslado } from "../helpers/etiquetasTraslado";

export const TrasladoSobranteTable = ({ trasladoForm }) => {
    const { destinoTraslado, sobranteTraslado } = trasladoForm;

    const {
        filas,
        valoresATrasladar,
        handleChangeATrasladar,
        tarjetasSalida,
        handleChangeTarjetaSalida,
        search,
        handleSearch,
    } = sobranteTraslado;

    const destinoEsConforme = destinoTraslado ? destinoTraslado.value : false;

    const {
        labelOrigen,
        labelDestino,
        claseOrigen,
        claseDestino,
        colorTarjeta,
    } = getEtiquetasTraslado(destinoEsConforme);

    return (
        <div className="mt-4 pt-3 border-top">
            <h4 className="mb-3">Kg secos sobrantes</h4>

            <BuscadorExistencias
                label="Buscar producto"
                placeholder="Nombre del producto"
                search={search}
                handleSearch={handleSearch}
            />

            <div className="new-table-wrapper traslado-control-calidad__table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th
                                colSpan={5}
                                className={`traslado-control-calidad__group-header ${claseOrigen} cell-border-right`}
                            >
                                {labelOrigen}
                            </th>
                            <th
                                colSpan={4}
                                className={`traslado-control-calidad__group-header ${claseDestino}`}
                            >
                                {labelDestino}
                            </th>
                        </tr>
                        <tr>
                            <th>Producto</th>
                            <th>Kg secos iniciales</th>
                            <th>A trasladar</th>
                            <th style={{ minWidth: "150px" }}>
                                Tarjeta {colorTarjeta}
                            </th>
                            <th className="cell-border-right">
                                Kg secos finales
                            </th>
                            <th>Producto</th>
                            <th>Kg secos iniciales</th>
                            <th>Trasladado</th>
                            <th>Kg secos finales</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filas.length === 0 && (
                            <tr>
                                <td className="text-center" colSpan={9}>
                                    No hay sobrantes con existencia en bodega
                                </td>
                            </tr>
                        )}
                        {filas.map((fila) => {
                            const kgInicialesOrigen = destinoEsConforme
                                ? fila.kg_secos_no_conforme
                                : fila.kg_secos_conforme;

                            const kgInicialesDestino = destinoEsConforme
                                ? fila.kg_secos_conforme
                                : fila.kg_secos_no_conforme;

                            const valor =
                                Number(valoresATrasladar[fila.producto_id]) ||
                                0;

                            const kgFinalesOrigen = kgInicialesOrigen - valor;

                            const kgFinalesDestino = kgInicialesDestino + valor;

                            const huboMovimiento = valor > 0;

                            return (
                                <tr key={fila.producto_id}>
                                    <td className="text-center text-nowrap">
                                        {fila.producto}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderKilogramo
                                            value={kgInicialesOrigen}
                                            decimalScale={2}
                                        />
                                    </td>
                                    <td className="text-center">
                                        <div
                                            className="mx-auto"
                                            style={{ maxWidth: "130px" }}
                                        >
                                            <NumberFormat
                                                className="form-control text-center"
                                                value={
                                                    valoresATrasladar[
                                                        fila.producto_id
                                                    ] || ""
                                                }
                                                thousandSeparator
                                                allowNegative={false}
                                                decimalScale={2}
                                                placeholder="0.00"
                                                disabled={
                                                    !destinoTraslado ||
                                                    kgInicialesOrigen <= 0
                                                }
                                                onValueChange={(values) => {
                                                    if (
                                                        values.value === "" ||
                                                        Number(values.value) <=
                                                            kgInicialesOrigen
                                                    ) {
                                                        handleChangeATrasladar(
                                                            fila.producto_id,
                                                            values.value,
                                                        );
                                                    }
                                                }}
                                                isAllowed={(values) => {
                                                    if (values.value === "") {
                                                        return true;
                                                    }

                                                    return (
                                                        Number(values.value) <=
                                                        kgInicialesOrigen
                                                    );
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td className="text-center">
                                        <div
                                            className="mx-auto"
                                            style={{ maxWidth: "110px" }}
                                        >
                                            <input
                                                type="text"
                                                className="form-control text-center"
                                                value={
                                                    tarjetasSalida[
                                                        fila.producto_id
                                                    ] || ""
                                                }
                                                placeholder="No. tarjeta"
                                                disabled={!huboMovimiento}
                                                onChange={(e) =>
                                                    handleChangeTarjetaSalida(
                                                        fila.producto_id,
                                                        e.target.value,
                                                    )
                                                }
                                            />
                                        </div>
                                    </td>
                                    <td
                                        className={`text-center text-nowrap cell-border-right
                                            ${
                                                huboMovimiento
                                                    ? "traslado-control-calidad__cell-highlight"
                                                    : "traslado-control-calidad__cell-highlight-gray"
                                            }`}
                                    >
                                        <RenderKilogramo
                                            value={kgFinalesOrigen}
                                            decimalScale={2}
                                        />
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {fila.producto}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderKilogramo
                                            value={kgInicialesDestino}
                                            decimalScale={2}
                                        />
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderKilogramo
                                            value={valor}
                                            decimalScale={2}
                                        />
                                    </td>
                                    <td
                                        className={`text-center text-nowrap
                                            ${
                                                huboMovimiento
                                                    ? "traslado-control-calidad__cell-highlight"
                                                    : "traslado-control-calidad__cell-highlight-gray"
                                            }`}
                                    >
                                        <RenderKilogramo
                                            value={kgFinalesDestino}
                                            decimalScale={2}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
